import { Component } from '@angular/core';

@Component({
  selector: 'app-cards8-examples-55',
  templateUrl: './cards8-examples-55.component.html'
})
export class Cards8Examples55Component {}
